module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-page"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', {
    staticClass: "inner-page-wrap"
  }, [_c('Header'), (_vm.props.better_featured_image) ? _c('div', {
    staticClass: "banner_section",
    style: ({
      backgroundImage: 'url(' + _vm.props.better_featured_image.source_url + ')'
    })
  }, [_c('div', {
    staticClass: "banner_overlay"
  }), (_vm.props.title.rendered) ? _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.title.rendered)
    }
  }) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "newpatient_section"
  }, [_c('div', {
    staticClass: "manual_container"
  }, [_c('div', {
    staticClass: "newpatientwrap clearfix"
  }, [_c('div', {
    staticClass: "newpatient_col"
  }, [(_vm.props.title.rendered) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.title.rendered)
    }
  }) : _vm._e(), (_vm.props.acf.thank_you_message) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.thank_you_message)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "sitemap_list"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/about-us"
    }
  }, [_vm._v("About Us")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/our-patient-is-you"
    }
  }, [_vm._v("Our Patient Is You")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/new-patients"
    }
  }, [_vm._v("New Patients")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Contact Us")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/thank-you"
    }
  }, [_vm._v("Thank You")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/sitemap"
    }
  }, [_vm._v("Sitemap")])], 1)])])])])]), (_vm.props.acf.thank_you_sideimg) ? _c('div', {
    staticClass: "custom_newpatient_img",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.thank_you_sideimg + ')'
    })
  }) : _vm._e()]), _c('Footer')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05502f72","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/sitemap/sitemap.pug
// module id = 511
// module chunks = 1